// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2qPO0","checkboxCol":"Table_checkboxCol__2ENmP","emailCol":"Table_emailCol__JlVGH","actionCol":"Table_actionCol__3l-tt"};